import { ACCOUNTANT_ROLE, ADMIN_ROLE, MANAGER_ROLE, USER_PROFILE_ROLES, USER_ROLE } from './user_profile_constants';

export const PERMISSIONS = {
  VIEW_SENSITIVE_FIELDS: 'view_sensitive_fields',
  VIEW_RESTRICTED_FIELDS: 'view_restricted_fields',
  VIEW_ALL_CARDS_AND_TRANSACTIONS: 'view_all_cards_and_transactions',
  VIEW_LINKED_ACCOUNT_RESTRICTED_FIELDS: 'view_linked_account_restricted_fields',
  VIEW_DEBIT_RESTRICTED_FIELDS: 'view_debit_restricted_fields',
  EDIT_EXPENSE_RULES_FIELDS: 'edit_expense_rules_fields',
  VIEW_BILL_PAY_RESTRICTED_FIELDS: 'view_bill_pay_restricted_fields',
  VIEW_EXPENSE_RESTRICTED_FIELDS: 'view_expense_restricted_fields',
  VIEW_ACCOUNTING_RESTRICTED_FIELDS: 'view_accounting_restricted_fields',
  VIEW_COMPANY_RESTRICTED_FIELDS: 'view_company_restricted_fields',
  VIEW_RESTRICTED_CARD_REQUEST_FIELDS: 'view_restricted_card_request_fields',
  VIEW_SENSITIVE_CARD_REQUEST_FIELDS: 'view_sensitive_card_request_fields',
  VIEW_ALL_CARD_REQUEST: 'view_all_card_request',
  VIEW_CARD_TRANSACTION_RESTRICTED_FIELDS: 'view_card_transaction_restricted_fields',
  CAN_APPROVE_DENY_EXPENSE: 'can_approve_deny_expense',
  MANAGE_USER_STATUS: 'manage_user_status',
  VIEW_EXPORT_RESTRICTED_FIELDS: 'view_export_restricted_fields',
  MANAGE_CARD_PROGRAMS: 'manage_card_programs'
} as const;

export type PERMISSION_TYPE = typeof PERMISSIONS[keyof typeof PERMISSIONS];

export const ROLE_PERMISSION_MAP: Record<USER_PROFILE_ROLES, PERMISSION_TYPE[]> = {
  [ADMIN_ROLE]: [
    PERMISSIONS.VIEW_SENSITIVE_FIELDS,
    PERMISSIONS.VIEW_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_ALL_CARDS_AND_TRANSACTIONS,
    PERMISSIONS.VIEW_LINKED_ACCOUNT_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_DEBIT_RESTRICTED_FIELDS,
    PERMISSIONS.EDIT_EXPENSE_RULES_FIELDS,
    PERMISSIONS.VIEW_BILL_PAY_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_EXPENSE_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_ACCOUNTING_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_COMPANY_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_RESTRICTED_CARD_REQUEST_FIELDS,
    PERMISSIONS.VIEW_SENSITIVE_CARD_REQUEST_FIELDS,
    PERMISSIONS.VIEW_ALL_CARD_REQUEST,
    PERMISSIONS.VIEW_CARD_TRANSACTION_RESTRICTED_FIELDS,
    PERMISSIONS.CAN_APPROVE_DENY_EXPENSE,
    PERMISSIONS.MANAGE_USER_STATUS,
    PERMISSIONS.VIEW_EXPORT_RESTRICTED_FIELDS,
    PERMISSIONS.MANAGE_CARD_PROGRAMS
  ],
  [MANAGER_ROLE]: [PERMISSIONS.VIEW_SENSITIVE_FIELDS, PERMISSIONS.VIEW_SENSITIVE_CARD_REQUEST_FIELDS, PERMISSIONS.CAN_APPROVE_DENY_EXPENSE],
  [ACCOUNTANT_ROLE]: [
    PERMISSIONS.VIEW_ALL_CARDS_AND_TRANSACTIONS,
    PERMISSIONS.VIEW_LINKED_ACCOUNT_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_DEBIT_RESTRICTED_FIELDS,
    PERMISSIONS.EDIT_EXPENSE_RULES_FIELDS,
    PERMISSIONS.VIEW_BILL_PAY_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_EXPENSE_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_ACCOUNTING_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_COMPANY_RESTRICTED_FIELDS,
    PERMISSIONS.VIEW_RESTRICTED_CARD_REQUEST_FIELDS,
    PERMISSIONS.VIEW_SENSITIVE_CARD_REQUEST_FIELDS,
    PERMISSIONS.VIEW_ALL_CARD_REQUEST,
    PERMISSIONS.VIEW_CARD_TRANSACTION_RESTRICTED_FIELDS,
    PERMISSIONS.CAN_APPROVE_DENY_EXPENSE,
    PERMISSIONS.VIEW_EXPORT_RESTRICTED_FIELDS
  ],
  [USER_ROLE]: []
};
